module.exports = __webpack_public_path__ + "img/18.8.aab5119e.png";